import React from 'react';
import PropTypes from 'prop-types';

import IconBolt from '../../assets/icons/source/bolt.svg';
import { TipStyled } from './Tip.styled';

const Tip = ({ content }) => (
  <TipStyled>
    <IconBolt />
    <span>{content}</span>
  </TipStyled>
);

Tip.propTypes = {
  content: PropTypes.string,
};

Tip.defaultProps = {
  content: '',
};

export default Tip;
